class Hero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.slideAway = self.elem.querySelector('[data-slide-away]');
    }

    init() {
        let self = this;

        window.addEventListener('scroll', () => {
            const scrollPosition = window.scrollY;

            // Calculate scroll opacity
            const opacity = Math.max(1 - scrollPosition / 500, 0);
      
            self.slideAway.style.transform = `translateX(-${scrollPosition}px)`;
            self.slideAway.style.opacity = opacity;
        });
    }
}

export default Hero;
